<template>
  <div>
    <div class="row">
      <div v-if="!printOnSite && physicalEnabled" class="col-12 col-md-6 col-lg-6">
        <b-card title="Post">
          <b-card-text>Manage and search for post</b-card-text>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="$router.push({name: 'post-search-physical'})"
          >
            All Post
          </b-btn>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="$router.push({
              name: 'post-search-physical',
              query: { deliveryStatus: 'sentForPrinting' }
            })"
          >
            Being Printed
          </b-btn>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="$router.push({
              name: 'post-search-physical',
              query: { deliveryStatus: 'dispatched' }
            })"
          >
            Dispatched
          </b-btn>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="$router.push({
              name: 'post-search-physical',
              query: { deliveryStatus: 'delivered' }
            })"
          >
            Delivered
          </b-btn>
        </b-card>
      </div>

      <div v-if="printOnSite && physicalEnabled" class="col-12 col-md-6 col-lg-6">
        <b-card title="Post (Print On Site)">
          <b-card-text>Manage and search for physical post</b-card-text>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="$router.push({
              name: 'print-on-site',
              query: {
                sentForPrinting: false,
                status: 'AwaitingConfirmation',
              }
            })"
          >
            Awaiting Confirmation
          </b-btn>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="$router.push({
              name: 'print-on-site',
              query: {
                status: 'Approved',
                sentForPrinting: false,
                delivered: false
              }
            })"
          >
            Ready For Print
          </b-btn>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="$router.push({
              name: 'print-on-site',
              query: {
                status: 'Approved',
                sentForPrinting: true,
                delivered: true,
              }
            })"
          >
            Printed
          </b-btn>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="$router.push({
              name: 'print-on-site',
              query: {
                status: 'Rejected',
                sentForPrinting: false,
                delivered: false
              }
            })"
          >
            Rejected Post
          </b-btn>
        </b-card>
      </div>

      <div v-if="repliesEnabled && physicalEnabled" class="col-12 col-md-6 col-lg-6">
        <b-card title="Post Replies">
          <b-card-text>Scan & upload replies</b-card-text>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="$router.push({name: 'post-reply-search'})"
          >
            Search Replies
          </b-btn>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="$router.push({name: 'post-replies'})"
          >
            Upload Replies
          </b-btn>
          <b-btn
            class="full-width btn-primary"
            variant="primary"
            @click="$router.push({name: 'post-replies-fail'})"
          >
            Failed Replies
          </b-btn>
        </b-card>
      </div>
    </div>

    <div class="row">
      <div v-if="digitalEnabled" class="col-12 col-md-6 col-lg-6">
        <b-card title="Digital Post">
          <b-card-text>Manage and search for digital post</b-card-text>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="$router.push({
              name: 'post-search-digital',
              query: { status: 'AwaitingConfirmation' }
            })"
          >
            Post Needing Approval
          </b-btn>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="$router.push({
              name: 'post-search-digital',
              query: { status: 'Approved' }
            })"
          >
            Approved Post
          </b-btn>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="$router.push({
              name: 'post-search-digital',
              query: { status: 'Rejected' }
            })"
          >
            Rejected Post
          </b-btn>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="$router.push({
              name: 'post-search-digital',
              query: {status: ''}
            })"
          >
            All Post
          </b-btn>
        </b-card>
      </div>

      <div v-if="digitalEnabled" class="col-12 col-md-6 col-lg-6">
        <b-card title="Digital Replies">
          <b-card-text>Manage and search for digital replies</b-card-text>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="$router.push({
              name: 'digital-replies',
              query: {
                status: 'AwaitingConfirmation',
              } ,
            })"
          >
            Replies Needing Approval
          </b-btn>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="$router.push({
              name: 'digital-replies',
              query: {
                status: 'Approved',
              } ,
            })"
          >
            Approved Replies
          </b-btn>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="$router.push({
              name: 'digital-replies',
              query: {
                status: 'Rejected',
              } ,
            })"
          >
            Rejected Replies
          </b-btn>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            @click="$router.push({
              name: 'digital-replies',
              query: {
                status: '',
              }
            })"
          >
            All Replies
          </b-btn>
        </b-card>
      </div>
    </div>

    <div class="row align-items-end">
      <div class="col-12 col-md-6 col-lg-6">
        <b-card title="Monitoring">
          <b-card-text>Search for, create, update and remove keywords & mail monitors</b-card-text>
          <b-btn
            class="full-width mb-1"
            variant="primary"
            :to="{name: 'keyword-search'}"
          >
            Manage Keywords
          </b-btn>
          <b-btn
            v-if="is_primary_user"
            class="full-width"
            variant="primary"
            :to="{name: 'mail-monitors'}"
          >
            Mail Monitors
          </b-btn>
        </b-card>
      </div>

      <div class="col-12 col-md-6 col-lg-6">
        <b-card title="Ban List">
          <b-card-text>Search for a sender who has been banned and remove any bans if needed</b-card-text>
          <b-card-text>
            <b-btn
              class="full-width mb-1"
              variant="primary" :to="{name: 'bans'}"
            >
              External User Bans
            </b-btn>
            <b-btn
              v-if="digitalEnabled && is_primary_user"
              class="full-width"
              variant="primary" :to="{name: 'digital-mail-restrictions'}"
            >
              Prisoner Bans
            </b-btn>
          </b-card-text>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Dashboard',
  components: {},
  computed: {
    ...mapState({
      digitalEnabled: state => state.auth.user.prison.purple_post_digital_enabled,
      physicalEnabled: state => state.auth.user.prison.purple_post_physical_enabled,
      printOnSite: state => state.auth.user.prison.purple_post_print_on_site,
      filters: state => state.postCard.filters,
      filtersDigitalReplies: state => state.digitalReplies.filters,
      repliesEnabled: state => state.auth.user.prison.purple_post_onsite_replies_enabled,
      is_primary_user: state => !state.auth.user.is_clinician && !state.auth.user.is_print_queue_user,
      is_clinician: state => state.auth.user.is_clinician,
      print_queue_user: state => state.auth.user.is_print_queue_user,
    }),
  },
  methods: {
    navigateToSearchPage(filters, digitalPost = false) {
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const filtersKey in filters) {
        this.updateFilter(filtersKey, filters[filtersKey]);
      }
      this.updateFilter('postType', digitalPost ? 'Digital' : 'Physical');

      this.$store.commit('postCard/SET_FILTERS', { ...this.filters }); // set new default filters
      this.$router.push({ name: 'post-search' });
    },
    updateFilter(filterName, e) {
      this.$store.commit('postCard/SET_FILTER_ITEM', { name: filterName, value: e });
    },
    navigateToDigitalRepliesPage(filters) {
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const filtersKey in filters) {
        this.updateFilterDigitalReply(filtersKey, filters[filtersKey]);
      }
      this.$router.push({ name: 'digital-replies' });
    },
    updateFilterDigitalReply(filterName, e) {
      this.$store.commit('digitalReplies/SET_FILTER_ITEM', { name: filterName, value: e });
    },
  },
}
</script>

<style>

</style>
